import React from 'react';
import { Button } from 'react-admin';
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';

const PrintButton = (props) => (
    <ReactToPrint
        trigger={() => <Button label="Imprimir" startIcon={<PrintIcon />} />}
        content={() => props.printRef.current}
    />
);

export default PrintButton;